import React from "react";
import LegalPageLayout from "../../components/common/LegalPageLayout";
import PrivacyPolicyData from "./TermsUse";

const PrivacyPolicy = () => (
  <LegalPageLayout
    pageTitle="Privacy Policy"
    effectiveDate="May 2, 2026"
    sections={PrivacyPolicyData}
  />
);

export default PrivacyPolicy;
